const protocol = process.env.NODE_ENV === 'development' ? 'http:' : window.location.protocol
const domainPort = window.location.port ? `:${window.location.port}` : ''

export const portLink = protocol + (process.env.NODE_ENV === 'development'
	? '//parking.ripperzx.ru:4480/api/' : `//${document.domain}${domainPort}/api/`)

export const imageLink = (sessionId, photoId,) => protocol + (process.env.NODE_ENV === 'development'
	? `//parking.ripperzx.ru:4480/api/8080/session-photo?photo=${photoId}&session=${sessionId}` : `//${document.domain}${domainPort}/api/8080/session-photo?photo=${photoId}&session=${sessionId}`)
